import React from 'react'
import { Form, Row, Col } from 'react-bootstrap'

import "./Forms.css"

function CheckBtn({required=true, type, formLabel, labels=[], name, onChange, value, checked}) {
  return (
    <Form onSubmit={(e) => e.preventDefault()}>
        {type==="inline" ?
            <Form.Group className="mb-1" controlId="formBasicEmail">
                <Row>
                    <Col sm={12}>
                        <Form.Label className='p-1 form-label align-left'>
                            {formLabel}
                            {/* {required && <span className='badge'>*</span>} */}
                        </Form.Label>
                    {/* </Col>
                    <Col sm={6}> */}
                    {['checkbox'].map((type) => (
                    <div key={`inline-${type}`} className=" align-left ">
                    {labels.map((data,key)=>{
                        return (  
                            <Form.Check
                            inline
                            label={data.label}
                            name={data.label}
                            type={type}
                            value={data.label}
                            onChange={onChange}
                            id={`inline-${type}-${key}`}
                            />
                        )
                    })}
                    </div>
                ))}
                    </Col>
                </Row>
            </Form.Group>
            :
           <>
             <Form.Group className="mb-1" controlId="formBasicEmail">
                <Row>
                    <Form.Label className='align-left ml-2 form-label'>
                        {formLabel}
                        {/* {required && <span className='badge'>*</span>} */}
                    </Form.Label>
                    <div className='align-left'>
                    {['checkbox'].map((type) => (
                        <div key={`block-${type}`} className="mb-3">
                        {labels.map((data,key)=>{
                            return (  
                                <Form.Check
                                inline
                                label={data.label}
                                name={name}
                                type={type}
                                value={value}
                                onChange={onChange}
                                id={`block-${type}-${key}`}
                                checked = {checked}
                                />
                            )
                        })}
                        </div>
                    ))}
                    </div>
                </Row>
            </Form.Group>
           </>
        }
    </Form>
    
  )
}

export default CheckBtn